import { Model } from 'jms-domain'

import type { DomainState } from '@salsita-ai/platform-project-sdk/domain'

import { configuratorInterface } from '../systems/configurator-interface.js'

const createDeleteUpdates = (state: DomainState<Model.AnyDomainEntity>) => {
  const deleteUpdates = state.entities
    .filter(e => !Model.StaticEntity.is(e))
    .map(wall =>
      configuratorInterface.updates.EntityDeletion({
        entityId: wall.id,
        updateTag: 'deleteWall',
      })
    )

  return deleteUpdates
}

/**
 * Clean up all entities on shape change.
 */
export const cleanUpWallsTransformerOnRoomShapeChange = configuratorInterface.transformerBuilder.when
  .entity(['Room'])
  .modified({ atFields: ['shape'] })
  .then.applySideEffect(ctx => {
    return createDeleteUpdates(ctx.getNewState())
  })
  .build('Clean up all entities on shape change')

export const cleanUpWallsTransformerOnWallLengthChange = configuratorInterface.transformerBuilder.when
  .entity(['Wall'])
  .modified({ atFields: ['length'] })
  .then.applySideEffect(ctx => {
    return createDeleteUpdates(ctx.getNewState())
  })
  .build('Clean up all entities on wall length change')
